import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AtDataModel } from "@tIntermatic/Services/INTPlaceOrderAPIService";
import { addAtDataFields as addAtDataApi } from "@tIntermatic/Services/INTPlaceOrderAPIService";

type AtParameter = {
    email?: string;
    first?: string;
    last?: string;
    street?: string;
    city?: string;
    zip?: string;
    phone?: string;
    ip?: string;
    userprofileid?: string;
    customerbilltoid?: string;
    customershiptoid?: string;
    isguest?: boolean;
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<AtParameter, AtDataModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await addAtDataApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitAtData = createHandlerChainRunner(chain, "AddAtDataFields");
export default submitAtData;
